/**
 * @generated SignedSource<<3154b8f42c87c96bf7c3464945f60820>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarPillsLazy_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarPills_item">;
  readonly " $fragmentType": "PdpRespSidebarPillsLazy_item";
};
export type PdpRespSidebarPillsLazy_item$key = {
  readonly " $data"?: PdpRespSidebarPillsLazy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarPillsLazy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarPillsLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarPills_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "05dfc764eadb696ebc7c57010571e6d2";

export default node;
